import business from "../Assets/Images/legal-services/Business.png";
import registration from "../Assets/Images/legal-services/Registration.png";
import taxation from "../Assets/Images/legal-services/Taxation.png";
import iso from "../Assets/Images/legal-services/ISO.png";
import ipr from "../Assets/Images/legal-services/IPR.png";

export const legalServicesData = [
  // Business Registration
  {
    id: "business-registration",
    slug: "business-registration",

    hero: {
      title: "Business Registration Services",
      subtitle:
        "Register your business with confidence. From proprietorships to companies, we provide end-to-end legal assistance for selecting the right business structure, documentation, registration, and post-registration compliance.",
      buttonText: "Get Started",
      image: business,
    },

    overview: {
      title: "Overview",
      description: `
Business Registration is the first and most important step towards establishing a legally recognized business in India. Choosing the appropriate business structure affects taxation, liability, ownership, investment opportunities, regulatory compliance, and future expansion.

Whether you are starting a small business, launching a startup, opening a manufacturing unit, or building a large corporate organization, registering your business provides legal recognition and builds trust among customers, financial institutions, investors, suppliers, and government authorities.

Every business structure has its own legal framework, compliance requirements, taxation rules, and operational flexibility. Selecting the right structure at the beginning helps avoid legal complications and supports long-term business growth.

At Webbocket Software Pvt. Ltd., we provide complete business registration services, including consultation, documentation, application filing, government approvals, PAN, TAN, GST assistance, and post-registration compliance support. Our experienced professionals ensure that your registration process is accurate, transparent, and completed within the prescribed timelines.
`,
    },

    features: {
      title: "Key Features",
      items: [
        {
          title: "Expert Business Consultation",
          description:
            "Get professional guidance to choose the most suitable business structure based on your goals, industry, and future growth plans.",
        },
        {
          title: "Complete Documentation Support",
          description:
            "Our experts help prepare, verify, and organize all required documents to ensure a smooth and error-free registration process.",
        },
        {
          title: "Government Filing & Registration",
          description:
            "We handle the complete filing process with the respective government authorities, ensuring timely and compliant registration.",
        },
        {
          title: "PAN, TAN & GST Assistance",
          description:
            "Receive end-to-end support for obtaining PAN, TAN, GST registration, and other mandatory statutory registrations.",
        },
        {
          title: "Fast & Transparent Process",
          description:
            "Experience a streamlined registration process with regular status updates, clear timelines, and no hidden charges.",
        },
        {
          title: "Post-Registration Compliance",
          description:
            "Beyond registration, we assist with ongoing legal compliance, annual filings, and regulatory requirements to keep your business compliant.",
        },
      ],
    },

    benefits: {
      title: "Benefits of Business Registration",
      items: [
        "Establishes your business as a legally recognized entity with government approval.",

        "Enhances brand credibility and builds trust among customers, suppliers, and business partners.",

        "Enables you to open a business current account and manage finances professionally.",

        "Makes your business eligible for government schemes, subsidies, startup benefits, and MSME incentives.",

        "Simplifies obtaining essential registrations such as GST, Import Export Code (IEC), and other business licenses.",

        "Improves access to bank loans, venture capital, investors, and other funding opportunities.",

        "Protects your business identity while creating a strong foundation for long-term growth and expansion.",

        "Ensures better legal compliance, tax planning, and hassle-free business operations.",
      ],
    },

    documents: {
      title: "Common Documents Required",
      items: [
        "PAN Card of the Proprietor, Partners, or Directors.",

        "Aadhaar Card or any valid identity proof of the applicant.",

        "Recent Passport Size Photographs of the authorized person(s).",

        "Valid Mobile Number and Email Address for official communication and OTP verification.",

        "Business Address Proof such as Electricity Bill, Water Bill, or Property Tax Receipt.",

        "Rent Agreement or Ownership Proof of the registered business premises, as applicable.",

        "No Objection Certificate (NOC) from the property owner if the premises are rented.",

        "Additional business-specific documents based on the selected business structure or regulatory requirements.",
      ],
    },

    process: {
      title: "Registration Process",
      steps: [
        {
          title: "Business Consultation",
          description:
            "Understand your business model and recommend the most suitable business structure.",
        },
        {
          title: "Document Collection",
          description:
            "Collect identity, address, business and statutory documents required for registration.",
        },
        {
          title: "Document Verification",
          description:
            "Verify all submitted documents before preparing the government application.",
        },
        {
          title: "Application Filing",
          description:
            "Prepare and submit the registration application to the appropriate government authority.",
        },
        {
          title: "Government Processing",
          description:
            "Coordinate with the concerned department during document verification and approval.",
        },
        {
          title: "Registration Certificate",
          description:
            "Receive the registration certificate along with other statutory registrations if applicable.",
        },
      ],
    },

    faqs: [
      {
        question: "Why should I register my business?",
        answer:
          "Business registration gives your enterprise legal identity, improves credibility, and enables access to banking, taxation, funding, and government benefits.",
      },
      {
        question: "Which business structure is best?",
        answer:
          "The ideal structure depends on your business size, ownership, liability, taxation, investment plans, and long-term objectives.",
      },
      {
        question: "How long does business registration take?",
        answer:
          "The timeline varies depending on the selected business structure and government approval process, generally ranging from a few days to a few weeks.",
      },
      {
        question: "Can I convert my business into another structure later?",
        answer:
          "Yes. Subject to legal provisions, businesses can be converted into other eligible business structures whenever required.",
      },
    ],

    cta: {
      title: "Register Your Business Today",
      description:
        "Our legal experts simplify the entire registration process so you can focus on growing your business while we take care of documentation, filing, approvals, and compliance.",
      buttonText: "Talk to an Expert",
    },

    subServices: [
      {
        slug: "partnership-firm",
        title: "Partnership Firm Registration",
        shortDescription:
          "Register a partnership business owned and managed by two or more individuals through a legally drafted Partnership Deed.",
      },

      {
        slug: "proprietorship-firm",
        title: "Proprietorship Firm Registration",
        shortDescription:
          "Start your business quickly with the simplest and most economical business structure for individual entrepreneurs.",
      },

      {
        slug: "llp-registration",
        title: "LLP Registration",
        shortDescription:
          "Combine partnership flexibility with limited liability protection through a Limited Liability Partnership.",
      },

      {
        slug: "private-limited-company",
        title: "Private Limited Company Registration",
        shortDescription:
          "Build a scalable and investment-friendly business through a Private Limited Company.",
      },

      {
        slug: "public-limited-company",
        title: "Public Limited Company Registration",
        shortDescription:
          "Register a public company capable of raising capital from the public while enjoying a separate legal identity and enhanced business credibility.",
      },

      {
        slug: "section-8-company",
        title: "Section 8 Company Registration",
        shortDescription:
          "Establish a legally recognized non-profit organization dedicated to charitable, educational, social, or environmental objectives.",
      },

      {
        slug: "producer-company",
        title: "Producer Company Registration",
        shortDescription:
          "Form a Producer Company for farmers and primary producers to promote collective production, marketing, and business growth.",
      },

      {
        slug: "nidhi-company",
        title: "Nidhi Company Registration",
        shortDescription:
          "Register a member-based Nidhi Company to encourage savings and provide loans exclusively among its members.",
      },

      {
        slug: "one-person-company",
        title: "One Person Company (OPC) Registration",
        shortDescription:
          "Enjoy the advantages of a Private Limited Company while operating your business as a single entrepreneur.",
      },

      {
        slug: "other-business-registration",
        title: "Other Business Registrations",
        shortDescription:
          "Get expert assistance for specialized business registrations, industry-specific approvals, and statutory registrations tailored to your business requirements.",
      },
    ],
  },

  // Registration
  {
    id: "registration",
    slug: "company-registration",

    hero: {
      title: "Registration Services",
      subtitle:
        "Simplify your regulatory journey with our comprehensive registration services. From GST and Startup recognition to BIS certification, barcode registration, PESO approvals, and educational affiliations, we provide end-to-end assistance for businesses, startups, institutions, and industries.",
      buttonText: "Get Started",
      image: registration,
    },

    overview: {
      title: "Overview",
      description: `
Registration is an essential legal requirement that enables businesses, startups, educational institutions, manufacturers, laboratories, and industrial organizations to operate in compliance with government regulations. Proper registration not only ensures legal recognition but also improves credibility, facilitates business growth, and helps organizations access government schemes, tax benefits, financial assistance, and market opportunities.

Different industries require different registrations depending on the nature of their business. Whether it is obtaining GST registration, Digital Signature Certificate (DSC), Startup recognition, BIS Certification, Barcode Registration, PESO approval, Educational Affiliation, or Testing Laboratory Licence, every registration has specific documentation and compliance requirements.

At Webbocket Software Pvt. Ltd., we provide complete registration assistance including consultation, documentation, application filing, government coordination, approval tracking, and post-registration support. Our experienced professionals ensure a hassle-free registration process while maintaining complete compliance with applicable laws and regulations.
`,
    },

    features: {
      title: "Key Features",
      items: [
        {
          title: "Expert Business Consultation",
          description:
            "Get professional guidance to choose the most suitable business structure based on your goals and compliance requirements.",
        },
        {
          title: "Complete Documentation Support",
          description:
            "We prepare, verify, and organize all required documents to ensure accurate and hassle-free registration.",
        },
        {
          title: "Government Filing & Registration",
          description:
            "Our experts handle the complete application filing process with the concerned government authorities on your behalf.",
        },
        {
          title: "Fast & Transparent Process",
          description:
            "Experience a streamlined registration process with regular updates, clear timelines, and no hidden charges.",
        },
        {
          title: "Compliance & Legal Assistance",
          description:
            "Receive expert support for statutory compliance, regulatory requirements, and legal documentation throughout the process.",
        },
        {
          title: "Post-Registration Support",
          description:
            "Get continued assistance for GST, PAN, bank account setup, licenses, and other essential business compliance needs.",
        },
      ],
    },

    benefits: {
      title: "Benefits of Registration Services",
      items: [
        "Ensures legal recognition and government compliance.",
        "Enhances business credibility and customer trust.",
        "Provides eligibility for government schemes and incentives.",
        "Reduces legal, regulatory, and compliance risks.",
        "Simplifies obtaining licenses, GST, and other registrations.",
        "Improves access to funding, banking, and investment opportunities.",
        "Supports smooth business operations and future expansion.",
        "Offers expert guidance with faster and hassle-free registration.",
      ],
    },
    documents: {
      title: "Common Documents Required",
      items: [
        "PAN Card of the Applicant or Authorized Signatory",
        "Aadhaar Card or any Valid Identity Proof",
        "Recent Passport Size Photograph",
        "Valid Mobile Number and Email Address",
        "Business Address Proof (Electricity Bill, Water Bill, etc.)",
        "Business Registration Certificate (if applicable)",
        "Proof of Ownership or Rent Agreement for Business Premises",
        "Additional Documents as Required by the Selected Registration Type",
      ],
    },
    process: {
      title: "Registration Process",
      steps: [
        {
          title: "Requirement Analysis",
          description:
            "Understand your business activity and identify the registration required.",
        },
        {
          title: "Document Collection",
          description:
            "Collect all necessary documents and verify their accuracy before application.",
        },
        {
          title: "Application Preparation",
          description:
            "Prepare the registration application along with supporting documents.",
        },
        {
          title: "Government Submission",
          description:
            "Submit the application to the respective government department or authority.",
        },
        {
          title: "Verification & Approval",
          description:
            "Coordinate with authorities during verification until approval is granted.",
        },
        {
          title: "Certificate Delivery",
          description:
            "Receive the registration certificate and provide post-registration guidance.",
        },
      ],
    },

    faqs: [
      {
        question: "Why are registrations important?",
        answer:
          "Registrations provide legal recognition, ensure regulatory compliance, and enable businesses to operate without legal complications.",
      },
      {
        question: "How long does registration take?",
        answer:
          "The processing time depends on the type of registration and the concerned government authority.",
      },
      {
        question: "Can Webbocket handle complete documentation?",
        answer:
          "Yes. We provide end-to-end documentation, filing, application tracking, and approval assistance.",
      },
      {
        question: "Do different registrations require different documents?",
        answer:
          "Yes. Documentation varies depending on the registration type, business activity, and applicable regulations.",
      },
    ],

    cta: {
      title: "Get Your Registration Completed Hassle-Free",
      description:
        "Our experts manage the entire registration process, ensuring accurate documentation, timely filing, government approvals, and complete legal compliance.",
      buttonText: "Talk to an Expert",
    },

    subServices: [
      {
        slug: "digital-signature-certificate",
        title: "Digital Signature Certificate (DSC)",
        shortDescription:
          "Obtain a legally valid Digital Signature Certificate for secure online document signing, MCA filings, GST compliance, Income Tax filing, and eTender participation.",
      },

      {
        slug: "gst-registration",
        title: "GST Registration",
        shortDescription:
          "Register your business under Goods and Services Tax (GST) to legally collect GST, claim Input Tax Credit, and conduct business across India.",
      },

      {
        slug: "startup-odisha",
        title: "Startup Odisha Registration",
        shortDescription:
          "Get your startup recognized under the Startup Odisha initiative and access state government incentives, funding, incubation, and mentorship.",
      },

      {
        slug: "startup-india",
        title: "Startup India Registration",
        shortDescription:
          "Obtain DPIIT recognition under Startup India to avail tax exemptions, funding opportunities, intellectual property support, and regulatory benefits.",
      },

      {
        slug: "educational-affiliation",
        title: "Educational Affiliation",
        shortDescription:
          "Secure affiliation and recognition for schools, colleges, coaching centres, universities, and educational institutions from the appropriate authorities.",
      },

      {
        slug: "industrial-documentation",
        title: "Industrial Documentation",
        shortDescription:
          "Professional documentation services for industrial approvals, factory registrations, project reports, and statutory compliance requirements.",
      },

      {
        slug: "other-registrations",
        title: "Other Registrations",
        shortDescription:
          "Comprehensive assistance for specialized business, industrial, and statutory registrations based on your industry requirements.",
      },

      {
        slug: "bis-certification",
        title: "BIS Certification",
        shortDescription:
          "Obtain Bureau of Indian Standards (BIS) certification to ensure product quality, regulatory compliance, and market acceptance in India.",
      },

      {
        slug: "barcode-registration",
        title: "Barcode Registration",
        shortDescription:
          "Register GS1 barcodes for your products to enable efficient inventory management, retail sales, and global product identification.",
      },

      {
        slug: "peso-license",
        title: "PESO License",
        shortDescription:
          "Obtain approval from the Petroleum and Explosives Safety Organization (PESO) for manufacturing, storage, transportation, and handling of petroleum and explosive products.",
      },

      {
        slug: "testing-laboratory-license",
        title: "Testing Laboratory Licence",
        shortDescription:
          "Obtain legal approvals and accreditation support for establishing and operating testing and calibration laboratories in compliance with applicable standards.",
      },
    ],
  },

  // Taxation
  {
    id: "taxation",
    slug: "taxation-services",

    hero: {
      title: "Taxation Services",
      subtitle:
        "Ensure complete tax compliance with our professional taxation services. From GST Return Filing and Income Tax Filing to ROC Compliance, Company Amendments, and Statutory Compliance, we provide end-to-end tax and regulatory solutions for businesses and professionals.",
      buttonText: "Get Started",
      image: taxation,
    },

    overview: {
      title: "Overview",
      description: `
Taxation is one of the most critical aspects of running a business. Timely tax compliance helps businesses avoid penalties, maintain legal compliance, and build financial credibility. Whether you are a startup, MSME, partnership firm, private limited company, NGO, or large enterprise, complying with taxation laws is essential for smooth business operations.

Our taxation experts provide comprehensive services including GST Return Filing, Income Tax Filing, Professional Tax Registration and Compliance, ROC Compliance, Company Amendments, and Statutory Compliance. We ensure accurate documentation, timely filings, regulatory compliance, and professional guidance to help businesses focus on growth while remaining compliant with applicable tax laws.

At Webbocket Software Pvt. Ltd., we offer reliable taxation solutions with complete transparency, personalized consultation, and dedicated support for individuals, professionals, and organizations across India.
`,
    },

    features: {
      title: "Key Features",
      items: [
        {
          title: "Expert Tax Consultation",
          description:
            "Receive professional guidance on GST, Income Tax, ROC filings, and statutory compliance tailored to your business requirements.",
        },
        {
          title: "Accurate Return Filing",
          description:
            "Ensure error-free preparation and timely filing of GST returns, Income Tax returns, TDS returns, and other statutory filings.",
        },
        {
          title: "Corporate Compliance Management",
          description:
            "Stay compliant with ROC regulations, annual filings, company amendments, and other mandatory corporate requirements.",
        },
        {
          title: "Timely Filing & Reminders",
          description:
            "Never miss important due dates with proactive reminders and timely submission of all regulatory filings.",
        },
        {
          title: "Regulatory & Legal Support",
          description:
            "Get expert assistance in handling legal documentation, notices, compliance queries, and government regulations.",
        },
        {
          title: "End-to-End Compliance Assistance",
          description:
            "From consultation and documentation to filing and post-compliance support, we manage the complete compliance lifecycle.",
        },
      ],
    },

    benefits: {
      title: "Benefits of Taxation Services",
      items: [
        "Ensures timely compliance with GST, Income Tax, ROC, and other statutory regulations.",
        "Helps avoid penalties, interest charges, and legal notices through accurate and timely filings.",
        "Maintains organized financial records for better business transparency and decision-making.",
        "Enhances business credibility with customers, investors, banks, and government authorities.",
        "Reduces compliance risks by ensuring adherence to the latest tax laws and regulations.",
        "Provides effective tax planning strategies to optimize tax liabilities and improve financial efficiency.",
        "Simplifies government filings with expert handling of documentation and return submissions.",
        "Offers year-round professional support for tax compliance, audits, notices, and regulatory queries.",
      ],
    },
    documents: {
      title: "Common Documents Required",
      items: [
        "PAN Card of the Individual or Business Entity",
        "Aadhaar Card or Valid Identity Proof",
        "GST Registration Certificate (if applicable)",
        "Business Registration Certificate or Incorporation Documents",
        "Bank Statements for the Relevant Financial Period",
        "Purchase and Sales Invoices with Supporting Bills",
        "Financial Statements including Profit & Loss Account and Balance Sheet",
        "Previous Income Tax Returns and Other Supporting Documents as Required",
      ],
    },

    process: {
      title: "Service Process",
      steps: [
        {
          title: "Consultation",
          description: "Understand your taxation and compliance requirements.",
        },
        {
          title: "Document Collection",
          description: "Collect financial records and statutory documents.",
        },
        {
          title: "Verification",
          description: "Review and verify all documents for accuracy.",
        },
        {
          title: "Preparation & Filing",
          description:
            "Prepare returns and submit them to the concerned authority.",
        },
        {
          title: "Compliance Monitoring",
          description:
            "Track filing status and respond to departmental queries if required.",
        },
        {
          title: "Completion",
          description:
            "Provide acknowledgements, certificates, and post-filing support.",
        },
      ],
    },

    faqs: [
      {
        question: "Why is timely tax compliance important?",
        answer:
          "Timely compliance helps avoid penalties, interest, legal notices, and maintains the financial credibility of your business.",
      },
      {
        question: "Who should file tax returns?",
        answer:
          "Individuals, businesses, companies, LLPs, firms, NGOs, and professionals are required to file returns based on applicable laws.",
      },
      {
        question: "Can you manage annual compliance?",
        answer:
          "Yes. We provide complete annual taxation and statutory compliance support for businesses.",
      },
      {
        question: "Do you provide consultation before filing?",
        answer:
          "Yes. Our experts review your business and recommend the best compliance approach before filing.",
      },
    ],

    cta: {
      title: "Stay Compliant with Professional Taxation Services",
      description:
        "Let our taxation experts handle your GST, Income Tax, ROC, and statutory compliance while you focus on growing your business.",
      buttonText: "Talk to an Expert",
    },

    subServices: [
      {
        slug: "gst-return-filing",
        title: "GST Return Filing",
        shortDescription:
          "Timely and accurate GST return filing services to ensure complete GST compliance and avoid penalties.",
      },

      {
        slug: "income-tax-filing",
        title: "Income Tax Filing",
        shortDescription:
          "Professional Income Tax Return (ITR) filing services for individuals, businesses, firms, LLPs, and companies.",
      },

      {
        slug: "professional-tax",
        title: "Professional Tax",
        shortDescription:
          "Registration, enrollment, payment, and compliance services for Professional Tax as per applicable state regulations.",
      },

      {
        slug: "post-compliances",
        title: "Post Compliances",
        shortDescription:
          "Comprehensive post-registration compliance services to ensure your business meets all ongoing statutory obligations.",
      },

      {
        slug: "roc-compliances",
        title: "ROC Compliances",
        shortDescription:
          "Complete Registrar of Companies (ROC) compliance services including annual filings, returns, and statutory documentation.",
      },

      {
        slug: "company-amendments",
        title: "Company Amendments",
        shortDescription:
          "Expert assistance for company amendments including changes in directors, registered office, name, object clause, share capital, and other statutory modifications.",
      },

      {
        slug: "statutory-compliance",
        title: "Statutory Compliance",
        shortDescription:
          "End-to-end statutory compliance services to help businesses comply with applicable corporate, tax, labour, and regulatory laws.",
      },
    ],
  },

  // ISO Certification
  {
    id: "iso-certification",
    slug: "iso-certification",

    hero: {
      title: "ISO Certification Services",
      subtitle:
        "Enhance your business credibility with internationally recognized ISO certifications. We provide complete assistance for ISO certification, documentation, implementation, audits, and certification support across various international standards.",
      buttonText: "Get Started",
      image: iso,
    },

    overview: {
      title: "Overview",
      description: `
ISO Certification demonstrates that your organization follows internationally accepted standards for quality, safety, security, environmental management, food safety, occupational health, and business operations. Achieving ISO certification enhances customer confidence, improves operational efficiency, strengthens regulatory compliance, and creates new business opportunities both nationally and internationally.

Whether you are a startup, manufacturing company, service provider, healthcare organization, educational institution, food business, IT company, laboratory, or government contractor, ISO certification helps improve your organization's credibility and competitive advantage.

At Webbocket Software Pvt. Ltd., we provide end-to-end ISO certification services including consultation, documentation, implementation guidance, internal audits, certification support, and post-certification assistance. Our experts simplify the certification process and help organizations achieve compliance with internationally recognized ISO standards.
`,
    },

    features: {
      title: "Key Features",
      items: [
        {
          title: "End-to-End ISO Certification Support",
          description:
            "Comprehensive assistance from initial consultation and documentation to successful ISO certification and final approval.",
        },
        {
          title: "Documentation & Compliance Assistance",
          description:
            "Expert preparation and review of policies, procedures, manuals, and records to meet ISO standard requirements.",
        },
        {
          title: "Gap Analysis & Implementation",
          description:
            "Identify compliance gaps, implement required improvements, and align your business processes with ISO standards.",
        },
        {
          title: "Internal Audit & Readiness Assessment",
          description:
            "Conduct internal audits and pre-certification assessments to ensure your organization is fully prepared for certification.",
        },
        {
          title: "Certification Body Coordination",
          description:
            "Seamless coordination with accredited certification bodies for scheduling audits and completing the certification process.",
        },
        {
          title: "Post-Certification Support",
          description:
            "Ongoing assistance for surveillance audits, compliance maintenance, recertification, and continuous process improvement.",
        },
      ],
    },

    benefits: {
      title: "Benefits of ISO Certification",
      items: [
        "Enhances your organization's credibility and builds trust among customers, partners, and stakeholders.",
        "Demonstrates commitment to international quality standards and best business practices.",
        "Improves operational efficiency by streamlining processes and reducing errors and waste.",
        "Increases customer satisfaction through consistent product and service quality.",
        "Strengthens eligibility for government tenders, corporate contracts, and global business opportunities.",
        "Ensures better regulatory compliance and promotes effective risk management across operations.",
        "Boosts your brand reputation and provides a competitive advantage in the marketplace.",
        "Supports continuous improvement and sustainable business growth through standardized processes.",
      ],
    },

    documents: {
      title: "Common Documents Required",
      items: [
        "Business Registration Certificate or Incorporation Documents",
        "PAN Card of the Business Entity or Authorized Signatory",
        "GST Registration Certificate (if applicable)",
        "Organization Profile and Business Activities Overview",
        "Quality Manual, Policies, and Process Documentation (if available)",
        "Standard Operating Procedures (SOPs) and Operational Records",
        "Employee Details, Organizational Structure, and Training Records",
        "Additional Documents as Required for the Selected ISO Standard and Certification Scope",
      ],
    },

    process: {
      title: "Certification Process",
      steps: [
        {
          title: "Consultation",
          description:
            "Understand your business operations and recommend the appropriate ISO standard.",
        },
        {
          title: "Gap Analysis",
          description:
            "Evaluate existing business processes against ISO requirements.",
        },
        {
          title: "Documentation",
          description:
            "Prepare manuals, policies, procedures, and mandatory documentation.",
        },
        {
          title: "Implementation",
          description:
            "Assist in implementing ISO-compliant management systems.",
        },
        {
          title: "Audit & Certification",
          description:
            "Coordinate with certification bodies and support during external audits.",
        },
        {
          title: "Certificate Issuance",
          description:
            "Receive ISO certification and ongoing compliance support.",
        },
      ],
    },

    faqs: [
      {
        question: "Why should my business obtain ISO certification?",
        answer:
          "ISO certification improves quality, customer trust, operational efficiency, and market credibility while helping businesses comply with international standards.",
      },
      {
        question: "How long does ISO certification take?",
        answer:
          "The duration depends on the selected ISO standard, organization size, and implementation readiness.",
      },
      {
        question: "Is ISO certification mandatory?",
        answer:
          "Most ISO certifications are voluntary, but many customers, government departments, and international buyers prefer or require certified organizations.",
      },
      {
        question: "Do you provide implementation support?",
        answer:
          "Yes. We provide complete implementation, documentation, audit, and certification assistance.",
      },
    ],

    cta: {
      title: "Get ISO Certified with Expert Guidance",
      description:
        "Our ISO consultants simplify documentation, implementation, audits, and certification, helping your organization achieve international standards with confidence.",
      buttonText: "Talk to an Expert",
    },

    subServices: [
      {
        slug: "iso-certification",
        title: "ISO Certification",
        shortDescription:
          "Complete assistance for obtaining internationally recognized ISO certifications for businesses across various industries.",
      },

      {
        slug: "iso-9001-2015-qms",
        title: "ISO 9001:2015 (Quality Management System)",
        shortDescription:
          "Improve product and service quality through an internationally recognized Quality Management System (QMS).",
      },

      {
        slug: "iso-14001-2015-ems",
        title: "ISO 14001:2015 (Environmental Management System)",
        shortDescription:
          "Implement effective environmental management practices to reduce environmental impact and ensure regulatory compliance.",
      },

      {
        slug: "iso-27001-2013-isms",
        title: "ISO 27001:2013 (Information Security Management System)",
        shortDescription:
          "Protect sensitive business information through a globally recognized Information Security Management System (ISMS).",
      },

      {
        slug: "iso-45001-2018-ohsms",
        title:
          "ISO 45001:2018 (Occupational Health & Safety Management System)",
        shortDescription:
          "Create a safer workplace by implementing an internationally accepted Occupational Health and Safety Management System.",
      },

      {
        slug: "iso-20000-2018-itms",
        title: "ISO 20000:2018 (IT Service Management System)",
        shortDescription:
          "Improve IT service delivery and operational efficiency through internationally recognized IT Service Management standards.",
      },

      {
        slug: "iso-22000-2018-fsms",
        title: "ISO 22000:2018 (Food Safety Management System)",
        shortDescription:
          "Ensure food safety across the supply chain with an internationally recognized Food Safety Management System.",
      },

      {
        slug: "iso-29990-2010-lms",
        title: "ISO 29990:2010 (Learning Services Management System)",
        shortDescription:
          "Enhance the quality of learning and training services through internationally accepted educational management standards.",
      },

      {
        slug: "iso-16949-2009",
        title: "ISO/TS 16949:2009",
        shortDescription:
          "Implement quality management standards specifically designed for the automotive manufacturing industry.",
      },

      {
        slug: "iso-13485-2016-mdms",
        title: "ISO 13485:2016 (Medical Devices Management System)",
        shortDescription:
          "Meet international quality requirements for the design, manufacture, and distribution of medical devices.",
      },

      {
        slug: "ce-marking",
        title: "CE Marking",
        shortDescription:
          "Obtain CE Marking to demonstrate compliance with European Union health, safety, and environmental protection requirements.",
      },

      {
        slug: "haccp-certification",
        title: "HACCP Certification",
        shortDescription:
          "Implement Hazard Analysis and Critical Control Points (HACCP) principles to ensure food safety and regulatory compliance.",
      },
    ],
  },

  // IPR Services
  {
    id: "ipr-services",
    slug: "ipr-services",

    hero: {
      title: "Intellectual Property Rights (IPR) Services",
      subtitle:
        "Protect your brand, innovations, creative works, and business identity through comprehensive Intellectual Property Rights registration, compliance, and legal support.",
      buttonText: "Get Started",
      image: ipr,
    },

    overview: {
      title: "Overview",
      description: `
Intellectual Property Rights (IPR) provide legal protection for creations of the mind, including trademarks, patents, industrial designs, copyrights, and other intellectual assets. Registering intellectual property safeguards your business identity, innovations, and creative works from unauthorized use while establishing exclusive ownership rights.

Whether you are launching a new brand, developing innovative technology, designing unique products, or creating original content, proper intellectual property protection enhances business value and strengthens your competitive position in the market.

At Webbocket Software Pvt. Ltd., we provide end-to-end IPR services including consultation, documentation, application filing, examination support, registration, renewals, compliance, and legal assistance. Our experts ensure a smooth registration process while helping businesses secure and maintain their valuable intellectual property rights.
`,
    },

    features: {
      title: "Key Features",
      items: [
        {
          title: "Comprehensive IPR Consultation",
          description:
            "Receive expert guidance to identify and protect your intellectual property through the most suitable registration strategy.",
        },
        {
          title: "Complete Documentation Support",
          description:
            "Our professionals prepare, review, and verify all required documents to ensure accurate and hassle-free application filing.",
        },
        {
          title: "Trademark, Patent & Copyright Registration",
          description:
            "End-to-end assistance for registering trademarks, patents, copyrights, industrial designs, and other intellectual property rights.",
        },
        {
          title: "Government Filing & Application Management",
          description:
            "We handle the complete filing process with the concerned authorities and track your application until successful registration.",
        },
        {
          title: "Legal Protection & Compliance Support",
          description:
            "Get expert assistance in responding to objections, renewals, assignments, and maintaining your intellectual property rights.",
        },
        {
          title: "End-to-End Professional Assistance",
          description:
            "From consultation and documentation to registration, renewal, and post-registration support, we manage the entire IPR lifecycle.",
        },
      ],
    },

    benefits: {
      title: "Benefits of IPR Registration",
      items: [
        "Secures exclusive legal ownership of your brand, invention, or creative work.",
        "Protects your intellectual property from unauthorized use, copying, and infringement.",
        "Enhances brand value and strengthens your business identity in the marketplace.",
        "Builds customer trust by establishing authenticity and ownership of your products and services.",
        "Creates valuable intangible assets that increase your company's overall business valuation.",
        "Provides opportunities for licensing, franchising, and royalty-based revenue generation.",
        "Strengthens your legal rights to take action against infringement and counterfeit activities.",
        "Improves your competitive advantage and supports long-term business growth in domestic and global markets.",
      ],
    },

    documents: {
      title: "Common Documents Required",
      items: [
        "PAN Card and Aadhaar Card of the Applicant or Authorized Signatory",
        "Valid Identity and Address Proof of the Applicant",
        "Business Registration Certificate (if applicable)",
        "Business Logo, Brand Name, or Trademark Artwork (for Trademark Registration)",
        "Authorization Letter or Power of Attorney (if filed through an agent)",
        "Technical Specification, Drawings, or Supporting Documents (for Patent Registration)",
        "Product or Service Details with Relevant Business Information",
        "Additional Documents as Required for the Selected IPR Service and Government Authority",
      ],
    },

    process: {
      title: "Registration Process",
      steps: [
        {
          title: "Initial Consultation",
          description:
            "Understand your intellectual property requirements and recommend the appropriate registration.",
        },
        {
          title: "Document Collection",
          description:
            "Collect identity documents, business details, and supporting intellectual property information.",
        },
        {
          title: "Application Preparation",
          description:
            "Prepare the necessary forms and legal documentation for filing.",
        },
        {
          title: "Government Filing",
          description:
            "Submit the application before the concerned Intellectual Property Office.",
        },
        {
          title: "Examination & Response",
          description:
            "Handle examination reports, objections, and necessary legal responses.",
        },
        {
          title: "Registration Certificate",
          description:
            "Receive the registration certificate and provide post-registration compliance support.",
        },
      ],
    },

    faqs: [
      {
        question: "What are Intellectual Property Rights?",
        answer:
          "IPR are legal rights that protect inventions, trademarks, creative works, industrial designs, and other intellectual assets.",
      },
      {
        question: "Why should I register my intellectual property?",
        answer:
          "Registration provides exclusive ownership, legal protection, and prevents unauthorized use by competitors.",
      },
      {
        question: "How long does IPR registration take?",
        answer:
          "The timeline depends on the type of intellectual property and the examination process followed by the respective authority.",
      },
      {
        question: "Can intellectual property be renewed?",
        answer:
          "Yes. Certain intellectual property rights such as trademarks require periodic renewal to maintain legal protection.",
      },
    ],

    cta: {
      title: "Protect Your Intellectual Property Today",
      description:
        "Our legal experts help you secure trademarks, patents, copyrights, and other intellectual property through a seamless registration and compliance process.",
      buttonText: "Talk to an Expert",
    },

    subServices: [
      {
        slug: "intellectual-property-rights",
        title: "Intellectual Property Rights (IPR)",
        shortDescription:
          "Comprehensive legal services for protecting trademarks, patents, copyrights, industrial designs, and other intellectual assets.",
      },

      {
        slug: "trademark-registration",
        title: "Trademark Registration",
        shortDescription:
          "Protect your brand name, logo, slogan, or symbol with official trademark registration and exclusive ownership rights.",
      },

      {
        slug: "design-registration",
        title: "Design Registration",
        shortDescription:
          "Secure the unique visual appearance, shape, pattern, or configuration of your products through design registration.",
      },

      {
        slug: "patent-registration",
        title: "Patent Registration",
        shortDescription:
          "Protect innovative inventions and technological developments with exclusive patent rights and legal recognition.",
      },

      {
        slug: "trademark-compliances",
        title: "Trademark Compliances",
        shortDescription:
          "Ensure timely trademark renewal, assignment, licensing, rectification, and other post-registration compliance services.",
      },

      {
        slug: "copyright-registration",
        title: "Copyright Registration",
        shortDescription:
          "Protect original literary, artistic, musical, software, and creative works through official copyright registration.",
      },
    ],
  },
];
